import { constants } from '../constants/redux-constants'
import { REHYDRATE } from 'redux-persist/lib/constants';
import i18n from 'multilingual';
import { signOut } from 'firebase/auth';
import { auth } from 'firebase-setup';
import { unixDate } from 'config/helpers/date_helper';

const initialState = {
    firstRender: true,
    language: 'en',
    loader: false,
    theme: 'light',
    page_loader: false,
    notification: [],
    isDashboardLoaded: false,
}

export default (state = initialState, action) => {

    switch (action.type) {
        case REHYDRATE:
            action.payload?.app.language && i18n.changeLanguage(action.payload?.app.language)
            return {
                ...state,
                ...action.payload?.app || {},
                theme: action.payload?.app.theme || 'light',
                isDashboardLoaded: false,
            };
        case constants.RESET:
            signOut(auth)
                ?.then(() => {
                    localStorage?.clear();
                })
                .catch(e => {
                    console.log(`some issue in firebase signout`, e);
                });
            return {
                ...initialState,
                theme: state.theme
            }
        case constants.CHANGE_LANGUAGE:
            return {
                ...state,
                language: action.payload
            }
        case constants.APP.CHANGE_THEME:
            return {
                ...state,
                theme: action.payload
            }
        case constants.APP.FULL_PAGE_LOADER:
            return {
                ...state,
                page_loader: action.payload
            }
        case constants.APP.TOGGLE_LOADER:
            return {
                ...state,
                loader: action.payload
            }
        case constants?.SET_DASHBOARD_LOADED:
            return {
                ...state,
                isDashboardLoaded: action.payload
            }
        case constants?.APP?.GENERATE_NOTIFICATIONS:
            return {
                ...state,
                    notification: [
                    {
                        message: action?.payload,
                        isRead: false,
                        addedOn: unixDate(new Date()),
                    },
                    ...state.notification, 
                    ],
            }
        case constants?.APP?.DELETE_NOTIFICATIONS:
            return {
                ...state,
                notification: state?.notification?.filter(notification => notification?.addedOn != action?.payload)
            };
        case constants?.APP?.READ_NOTIFICATIONS:
            return {
                ...state,
                notification: state?.notification?.map(notification => {
                    return {
                        ...notification,
                        isRead: true
                    }
                })
            };
        case constants?.APP?.CLEAR_NOTIFICATIONS:
            return {
                ...state,
                notification: []
            }
        default:
            return {
                ...state
            }
    }
}